<div class="detail-page">
  <a class="detail-back" [routerLink]="['/sender/list']">
    <app-detail-icon name="arrow-left" [size]="15"></app-detail-icon>
    Back to Senders
  </a>

  <ng-container *ngIf="senderData as sender">
    <!-- Header: identity + actions -->
    <header class="detail-header">
      <div>
        <h1 class="detail-header__title">{{ fullName }}</h1>
        <div class="detail-header__meta">
          <span class="detail-mono">S{{ sender.sender_id }}</span>
          <a [href]="'mailto:' + sender.email">{{ sender.email }}</a>
        </div>
      </div>

      <div class="detail-header__actions" *appHasAccess="'/sender/edit/:id'">
        <span class="detail-toggle">
          <mat-slide-toggle
            labelPosition="before"
            [checked]="sender.is_device_verification_required"
            (change)="toggleDeviceVerification($event)">
            Device Verification
          </mat-slide-toggle>
        </span>
        <button
          type="button"
          class="detail-btn detail-btn--accent"
          [routerLink]="['/sender/edit', sender.sender_id]">
          <app-detail-icon name="pencil" [size]="14"></app-detail-icon>
          Edit
        </button>
        <button
          type="button"
          class="detail-btn"
          [ngClass]="{ 'detail-btn--warn': sender.is_active }"
          (click)="toggleActiveStatus()">
          <app-detail-icon name="power" [size]="14"></app-detail-icon>
          {{ sender.is_active ? 'Deactivate' : 'Activate' }}
        </button>
        <button type="button" class="detail-btn" (click)="updateKycStatus()">
          <app-detail-icon name="shield-check" [size]="14"></app-detail-icon>
          Update KYC
        </button>
        <button type="button" class="detail-btn" (click)="updateAmlStatus()">
          <app-detail-icon name="shield" [size]="14"></app-detail-icon>
          Update AML
        </button>
        <button type="button" class="detail-btn" (click)="resetPassword()">
          <app-detail-icon name="lock" [size]="14"></app-detail-icon>
          Reset Password
        </button>
        <button type="button" class="detail-btn" (click)="resetPin()">
          <app-detail-icon name="key" [size]="14"></app-detail-icon>
          Reset PIN
        </button>
      </div>
    </header>

    <div class="detail-stack">
      <div class="detail-grid">
        <!-- Sender information -->
        <section class="detail-card">
          <div class="detail-card__head">
            <app-detail-icon
              class="detail-card__icon"
              name="user"
              [size]="18"></app-detail-icon>
            <h2 class="detail-card__title">Sender Information</h2>
          </div>

          <div class="detail-kv">
            <span class="detail-kv__label">Status</span>
            <span class="detail-kv__value">
              <span class="detail-pill" [ngClass]="sender.is_active | statusPill">
                {{ sender.is_active ? 'Active' : 'Inactive' }}
              </span>
              <span
                class="detail-pill detail-pill--danger"
                *ngIf="sender.is_deleted">
                Deleted
              </span>
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">Email</span>
            <span class="detail-kv__value">
              <span
                class="detail-pill"
                [ngClass]="
                  sender.status.includes('EMAIL-OK')
                    ? 'detail-pill--success'
                    : 'detail-pill--plain'
                ">
                {{
                  sender.status.includes('EMAIL-OK') ? 'Verified' : 'Unverified'
                }}
              </span>
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">Mobile</span>
            <span class="detail-kv__value">
              <span
                class="detail-pill"
                [ngClass]="
                  sender.is_mobile_verified
                    ? 'detail-pill--success'
                    : 'detail-pill--plain'
                ">
                {{ sender.is_mobile_verified ? 'Verified' : 'Unverified' }}
              </span>
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">Sender ID</span>
            <span class="detail-kv__value detail-mono">
              {{ sender.sender_id }}
            </span>
          </div>
          <div class="detail-kv" *ngIf="isSuperAdmin">
            <span class="detail-kv__label">Partner ID</span>
            <span class="detail-kv__value detail-mono">
              {{ sender.partner_id }}
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">Source Country</span>
            <span class="detail-kv__value">
              <img
                [src]="
                  'assets/images/country-square/' +
                  sender.source_country +
                  '.png'
                "
                alt=""
                class="detail-flag me-1"
                onerror="this.style.display='none'" />
              {{ sender.source_country }}
            </span>
          </div>

          <div class="detail-iconrow">
            <app-detail-icon
              class="detail-iconrow__icon"
              name="mail"
              [size]="16"></app-detail-icon>
            <span class="detail-iconrow__value">
              <a [href]="'mailto:' + sender.email">{{ sender.email }}</a>
            </span>
          </div>
          <div class="detail-iconrow">
            <app-detail-icon
              class="detail-iconrow__icon"
              name="phone"
              [size]="16"></app-detail-icon>
            <span class="detail-iconrow__value">
              <a [href]="'tel:' + sender.mobile_code + sender.mobile_number">
                {{ sender.mobile_code }} {{ sender.mobile_number }}
              </a>
            </span>
          </div>
          <div class="detail-iconrow" *ngIf="sender.created_at">
            <app-detail-icon
              class="detail-iconrow__icon"
              name="calendar"
              [size]="16"></app-detail-icon>
            <span>
              <span class="detail-iconrow__label d-block">Member Since</span>
              <span class="detail-iconrow__value">
                {{ sender.created_at | date: 'MMM d y, hh:mm a' }}
              </span>
            </span>
          </div>

          <div class="detail-section">
            <div class="detail-section__title">Profile</div>
            <div class="detail-kv">
              <span class="detail-kv__label">Full Name</span>
              <span class="detail-kv__value">{{ fullName }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Gender</span>
              <span class="detail-kv__value">{{ sender.gender || '—' }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Date of Birth</span>
              <span class="detail-kv__value">
                {{ sender.date_of_birth || '—' }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Nationality</span>
              <span class="detail-kv__value">
                {{ sender.nationality || '—' }}
              </span>
            </div>
          </div>

          <div class="detail-section">
            <div class="detail-section__title">Address</div>
            <div class="detail-kv">
              <span class="detail-kv__label">Address Line 1</span>
              <span class="detail-kv__value">{{ sender.address1 || '—' }}</span>
            </div>
            <div class="detail-kv" *ngIf="sender.address2">
              <span class="detail-kv__label">Address Line 2</span>
              <span class="detail-kv__value">{{ sender.address2 }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">City</span>
              <span class="detail-kv__value">{{ sender.city || '—' }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Postal Code</span>
              <span class="detail-kv__value">
                {{ sender.postal_code || '—' }}
              </span>
            </div>
          </div>
        </section>

        <!-- KYC & compliance -->
        <section class="detail-card">
          <div class="detail-card__head">
            <app-detail-icon
              class="detail-card__icon"
              name="shield"
              [size]="18"></app-detail-icon>
            <h2 class="detail-card__title">KYC & Compliance</h2>
          </div>

          <div class="detail-kv">
            <span class="detail-kv__label">KYC Status</span>
            <span class="detail-kv__value">
              <span class="detail-pill" [ngClass]="sender.kyc_status | statusPill">
                {{ sender.kyc_status || 'Not set' }}
              </span>
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">AML Status</span>
            <span class="detail-kv__value">
              <span class="detail-pill" [ngClass]="sender.aml_status | statusPill">
                {{ sender.aml_status || 'Not set' }}
              </span>
            </span>
          </div>

          <div class="detail-section">
            <div class="detail-section__title">
              Documents · {{ documentCount }}
            </div>

            <ng-container *ngIf="documentCount; else noDocuments">
            <div class="detail-tile" *ngFor="let doc of sender.documents">
              <div class="d-flex justify-content-between align-items-start gap-2">
                <div>
                  <div class="detail-tile__title">
                    {{ doc.document_type | formatText | titlecase }}
                  </div>
                  <div class="detail-tile__sub">
                    {{ doc.document_section.replace('-', ' ') | titlecase }}
                  </div>
                </div>
                <span
                  class="detail-pill"
                  *ngIf="doc.kyc_status"
                  [ngClass]="doc.kyc_status | statusPill">
                  {{ doc.kyc_status }}
                </span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv__label">Document #</span>
                <span class="detail-kv__value detail-mono">
                  {{ doc.document_number || '—' }}
                </span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv__label">Expiry Date</span>
                <span class="detail-kv__value">
                  {{ doc.document_expiry_date || '—' }}
                </span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv__label">Upload ID</span>
                <span class="detail-kv__value detail-mono">
                  {{ doc.upload_id || '—' }}
                </span>
              </div>
              <button
                *ngIf="doc.image"
                type="button"
                class="detail-btn detail-btn--block mt-2"
                (click)="viewDocument(doc)">
                <app-detail-icon name="eye" [size]="14"></app-detail-icon>
                View Document
              </button>
            </div>
            </ng-container>
            <ng-template #noDocuments>
              <div class="detail-empty">
                <app-detail-icon name="file-x" [size]="28"></app-detail-icon>
                <p>No documents uploaded</p>
              </div>
            </ng-template>
          </div>
        </section>
      </div>

      <!-- Related records -->
      <section class="detail-tabs">
        <mat-tab-group>
          <mat-tab label="Transactions">
            <ng-template matTabContent>
              <app-sender-transaction-list
                [id]="id"
                [isSuperAdmin]="isSuperAdmin"></app-sender-transaction-list>
            </ng-template>
          </mat-tab>
          <mat-tab label="Recipients">
            <ng-template matTabContent>
              <app-sender-recipient-list
                [id]="id"
                [isSuperAdmin]="isSuperAdmin"></app-sender-recipient-list>
            </ng-template>
          </mat-tab>
          <ng-container *ngIf="!isSuperAdmin">
            <mat-tab label="Wallets" *appHasAccess="'/wallet/list'">
              <ng-template matTabContent>
                <app-sender-wallet-list [senderId]="id"></app-sender-wallet-list>
              </ng-template>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
      </section>
    </div>
  </ng-container>
</div>
